import { useRef, useState } from "react";

import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function AdminLoginCard({
  configured,
  onLogin,
  isLoading,
  error,
}: {
  configured: boolean;
  onLogin: (args: { email?: string; password: string }) => void;
  isLoading: boolean;
  error?: string;
}) {
  const [email, setEmail] = useState("");
  const passwordRef = useRef<HTMLInputElement | null>(null);

  return (
    <Card className="mx-auto w-full max-w-md p-5">
      <div className="font-display text-xl font-semibold tracking-tight">Yönetim girişi</div>
      <div className="mt-1 text-sm text-muted-foreground">
        {configured
          ? "Devam etmek için yönetici e‑posta ve şifren ile giriş yap."
          : "Admin girişi ayarlı değil (sunucu ayarı eksik)."}
      </div>

      <form
        className="mt-4 grid gap-3"
        onSubmit={(e) => {
          e.preventDefault();
          if (!configured) return;
          const password = passwordRef.current?.value ?? "";
          onLogin({ email: email.trim() || undefined, password });
          if (passwordRef.current) passwordRef.current.value = "";
        }}
      >
        <div className="grid gap-2">
          <Label htmlFor="admin_email">E‑posta</Label>
          <Input
            id="admin_email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={!configured || isLoading}
            placeholder="ornek@mail.com"
          />
        </div>

        <div className="grid gap-2">
          <Label htmlFor="admin_password">Şifre</Label>
          <Input
            id="admin_password"
            type="password"
            ref={passwordRef}
            autoComplete="current-password"
            disabled={!configured || isLoading}
          />
        </div>

        {error ? (
          <div className="rounded-lg border border-destructive/30 bg-destructive/10 p-3 text-sm text-destructive">
            {error}
          </div>
        ) : null}

        <Button type="submit" className="rounded-full" disabled={!configured || isLoading}>
          {isLoading ? "Giriş yapılıyor..." : "Giriş yap"}
        </Button>
      </form>

      <div className="mt-4 text-xs leading-relaxed text-muted-foreground">
        Not: Bu panel sadece yönetici kullanımı içindir. Şifreyi kimseyle paylaşmayın.
      </div>
    </Card>
  );
}
